<template>
    <div>
        <section id="market-research-results">
            <div :class="containerClasses">
                <div class="row">
                    <div class="search-result-top">
                        <div class="top" v-if="!showHeading">
                            <div class="left">
                                <h2>
                                    Market Research
                                </h2>
                            </div>
                        </div>
                        <div class="bottom space-between">
                            <div class="left">
                                <span class="showing">
                                    <strong>Showing</strong>
                                    <span>{{ startFrom }}</span>-<span>{{ endNumber }}</span> of <span>{{ totalRecords }}</span>
                                    results
                                </span>
                                <!--<a class="link select-all" @click="toggleSelectAll">{{selectAllText}}</a>-->
                                <a v-if="perPage !== 500" class="link show-max" @click="showMax()">Max</a>
                                <select class="per-page" v-model="perPage" @change="getData();setSearchSettings();">
                                    <option v-for="option in per_page_options" :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="right">
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-12 pull-right">
                            <b-pagination v-if="totalRecords > (currentPage - 1) * perPage" align="right" :total-rows="totalRecords" v-model="currentPage"
                                          :per-page="perPage" @change="getPagination()"></b-pagination>
                        </div>
                    </div>
                    <div class="container-results" id="container-results">
                        <div class="all-bid table-responsive" v-if="results">
                            <table class="bid-history table list-table table-hover">
                                <thead>
                                <tr>
                                    <th>
                                        <a href="#!" @click.prevent="toggleSorting('time')" title="Click to sort by auction date ">
                                            Day
                                        </a>
                                    </th>
                                    <th> Auc /   Lot
                                    </th>
                                    <th>ID</th>
                                    <th>Make</th>
                                    <th>Model/Grade</th>
                                    <th>Chassis</th>
                                    <th>
                                        <a href="#!" @click.prevent="toggleSorting('a_year', 'd_year')" title="Click to sort by year ">
                                            Year
                                        </a>
                                    </th>
                                    <th>Kms</th>
                                    <th>Colour</th>
                                    <th>CC</th>
                                    <th>Trans</th>
                                    <th>F</th>
                                    <th>Cnd</th>
                                    <th></th>
                                    <th>
                                        <a href="#!" @click.prevent="toggleSorting('a_endprice', 'd_endprice')" title="Click to sort by price ">
                                            Result
                                        </a>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(data,index) in results">
                                    <tr :key="data.api_id" class="hr">
                                        <td class="date">
                                            {{ getDate(data.auction_date) }}
                                        </td>
                                        <td class="yellow">
                                            <a :href="data.detail_url" @click.prevent="goToCar(data)">
                                                <div>{{ data.auction_house }}</div>
                                                <div>{{ data.lot }}</div>
                                            </a>
                                        </td>
                                        <td class="id-bid">
                                            <a class="link" :href="data.detail_url" @click.prevent="goToCar(data)">
                                                {{ data.api_id }}
                                            </a>
                                            <div class="image-hover-container">
                                                <vehicle-hover-images :vehicle="data" :letters_only="true"></vehicle-hover-images>
                                            </div>
                                        </td>
                                        <td class="make">
                                            {{ data.make }}
                                        </td>
                                        <td class="model">
                                            {{ data.model }} / {{ data.grade }}
                                        </td>
                                        <td>
                                            {{ data.chassis }}
                                        </td>
                                        <td>
                                            {{ data.year }}
                                        </td>
                                        <td>
                                            {{ data.mileage }}
                                        </td>
                                        <td class="color">
                                            {{ data.color }}
                                        </td>
                                        <td>
                                            {{ data.engine_capacity }}
                                        </td>
                                        <td>
                                            {{ data.transmission }}
                                        </td>
                                        <td>
                                            {{ data.fuel_type }}
                                        </td>
                                        <td>
                                            {{ data.condition }}
                                        </td>
                                        <td>
                                            {{ data.equipment }}
                                        </td>
                                        <td class="sold">
                                            <span v-if="data.bid_status === 'negotiation'">Negotiation</span>
                                            <span v-else-if="data.bid_status === 'cancelled'">Cancelled</span>
                                            <span v-else-if="data.bid_status === 'sold'">Sold</span>
                                            <span v-else>Not sold</span>
                                            <template v-if="data.end_price && data.end_price > 0">
                                                <br/>
                                                <span :title="numberWithCommas(data.end_price) + ' yen'"
                                                      class="blue">
                                                    ¥ {{ numberWithCommas(data.end_price / 1000) }} k
                                                </span>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!results.length && !loading" class="ml-4">
                            No results containing all your search were found
                        </div>
                        <div v-if="loading" class="container-results" id="loading-results">
                            <img src="/images/loading.svg" alt="Loading..." class="loader"/>
                        </div>
                    </div>
                    <div class="bottom-container-result">
                        <div class="col-lg-3 col-md-2 col-12">
                            <!--<a class="link select-all" @click="toggleSelectAll">{{selectAllText}}</a>-->
                            <a v-if="perPage !== 500" class="link show-max" @click="showMax()">Max</a>
                        </div>
                        <div class="col-lg-3 col-md-3 col-12 pull-right">
                            <b-pagination v-if="totalRecords > (currentPage - 1) * perPage" align="right" :total-rows="totalRecords" v-model="currentPage"
                                          :per-page="perPage" @change="getPagination()"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import moment from 'moment'
    import refineSearch from './RefineSearch.vue';
    import Vehicle from './Common/Vehicle';
    import {mapState, mapActions, mapMutations} from 'vuex'
    import {
        handleHttpError,
        getExceptionErrorMessage,
        setVehicleNextPrev,
        objToUrl,
        numberWithCommas,
        getDateTime,
        getNZDateTime,
        getJapanDiff,
        getLocalData,
        storeLocalData,
        setBackToAll,
        hashString, addToUrlQuery,
    } from '../util/common'
    import VehicleHoverImages from './Common/VehicleHoverImages'

    export default {
        props: [
            'searchfields',
            'past',
        ],
        components: {
            VehicleHoverImages
        },
        created() {
            this.setLoading(false);
            this.getSearchSettings();
            if (this.$route.query.sort_by) {
                this.sortOrderBy = this.$route.query.sort_by
            }
            this.$store.dispatch('stock_nextprev/checkStack');
            this.$nextTick(async () => {
                if (this.$route.query.cache_key) {
                    await this.getData(this.$route.query.cache_key);
                    await this.$store.dispatch('stock_nextprev/checkListReturn', this.$route.query.state_key || null)
                } else {
                    await this.getData();
                }
            })
        },
        data() {
            return {
                saveSearchData: this.searchfields,
                showSearchBidBox: true,
                results: [],
                recommendModelOpen: false,
                emailModelOpen: false,
                vehicleIds: [],
                perRow: 0,
                totalRecords: 0,
                favListModalOpen: false,
                resultCacheKey: null,
                vehicleList: [],
                sortOrderBy: 'make',
                selected: {},
                translatedGrades: {},
                isCurrentSelected: false,
                searchFieldData: '',
                bid: '',
                tags: [],
                vehicle_id: '',
                sbl_vehicle_id: '',
                priceField: this.past ? 'end_price' : 'start_price',
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                per_page_options: [
                    {value: 50, text: '50 per page'},
                    {value: 100, text: '100 per page'},
                    {value: 250, text: '250 per page'},
                    {value: 500, text: '500 per page'},
                ],
                dataRetrievalCancelTokenSource: null,
                notifyMessageSendEmail: 'We’ve hand-picked some vehicles in the upcoming auctions that may work for you. Get in touch with me for more information on any of these vehicles',
                recommendMessageSendEmail: "I’ve hand-picked some vehicles that are going through auctions today that I hope you like. \n\n Look forward to seeing your bids soon. 🚗 😀 🥇"
            }
        },
        computed: {
            ...mapState({
                loading: state => state.market_research.loading,
                loadVehicles: state => state.loadVehicleForEmail.all,
                resultsCache: state => state.auction_search.resultsCache,
            }),
            showHeading(){
                if (this.$router.query && this.$router.query.iframe) {
                    return false
                }
                return true
            },
            resultBlockWidth() {
                if (this.perRow) {
                    return {
                        width: 'calc(' + 100 / this.perRow + '% - 5px)'
                    }
                }
                return '';
            },
            containerClasses() {
                let classes = ['container', 'full-width'];
                return classes.join(' ');
            },
            currentPage: {
                get () {
                    return this.$store.getters['auction_search/getCurrentPage']
                },
                set (value) {
                    this.$store.commit('auction_search/setCurrentPage', value)
                }
            },
            perPage: {
                get () {
                    return this.$store.getters['auction_search/getPerPage']
                },
                set (value) {
                    this.$store.commit('auction_search/setPerPage', value)
                }
            },
            startFrom () {
                return (this.currentPage - 1) * this.perPage + 1;
            },
            endNumber () {
                let endNumber = this.perPage * this.currentPage
                if (endNumber > this.totalRecords) {
                    endNumber = this.totalRecords
                }
                return endNumber
            }
        },
        methods: {
            ...mapActions({
                translateGrades: 'market_research/translateGrades',
                addToNextPrevStack: 'auction_nextprev/addToStack',
            }),
            ...mapMutations({
                setLoading: 'market_research/setLoading',
                setSingleVehicle: 'auction_search/setSingleVehicle',
                setResultsCache: 'market_research/setResultsCache',
            }),
            numberWithCommas,
            getDateTime,
            getNZDateTime,
            getJapanDiff,
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            toggleSorting(first, second = null){
                if (second) {
                    if (this.sortOrderBy === first) {
                        this.sortOrderBy = second
                    } else {
                        this.sortOrderBy = first
                    }
                } else {
                    this.sortOrderBy = first
                }
                this.getData()
            },
            goToCar(vehicle){
                this.setSingleVehicle(vehicle)
                let url = vehicle.detail_url
                if (window.history && window.history.state && window.history.state.key) {
                    this.$store.dispatch('auction_nextprev/leavingListPage')
                    url = addToUrlQuery(url, {state_key: window.history.state.key})
                }
                this.$router.push(url)
            },
            log() {
                console.log(arguments);
            },
            getPagination() {
                this.$nextTick(() => {
                    this.getData();
                })
            },
            showTip(event) {
                var container = $(event.target).parent();
                container.find('.tip').css('transform', 'scaleY(1)');
            },
            hideTip() {
                var container = $(event.target).parent().parent().parent();
                container.find('.tip').css('transform', 'scaleY(0)');
            },
            setSearchSettings() {
                let data = {
                    vehicle_search_per_page: this.perPage,
                    vehicle_search_per_row: this.perRow,
                };

                this.axios.post(this.$laravelRoute('set-search-settings'), data);
            },
            getSearchSettings() {
                if (this.loggedInUser && this.loggedInUser.search_settings){
                    this.perPage = this.loggedInUser.search_settings.vehicle_search_per_page;
                    this.perRow = this.loggedInUser.search_settings.vehicle_search_per_row;
                }
            },
            async getData(cache_key) {
                const afterLoaded = ()  => {
                    if (this.$router && this.$router.lastScrollPosition) {
                        this.$nextTick(() => {
                            document.documentElement.scrollTop = this.$router.lastScrollPosition.y;
                        })
                    }
                    this.setLoading(false);
                }
                const onError = (err) => {
                    this.setLoading(false)
                    console.warn('there was a problem loading the vehicles', err)
                }
                const loadVehicles = (response) => {
                    let ids = [];
                    let vehicles = response.results.results
                    this.$_.each(vehicles, item => {
                        ids.push(item.api_id);
                    });
                    this.addToNextPrevStack({ids})
                    this.results = vehicles;
                    this.resultCacheKey = response.cache_key;
                    this.setResultsCache({key: response.cache_key, results: this.results})
                    this.totalRecords = response.results.total_count;
                }
                const retrieveData = (perpage, setviewed)  => {
                    return new Promise((resolve, reject) => {
                        let query_data = JSON.parse(JSON.stringify(data));
                        query_data.market_research = true
                        if (query_data.currentPage !== 1 && perpage !== query_data.perpage) { //
                            query_data.currentPage = (query_data.perpage / perpage) * (query_data.currentPage - 1) + 1
                        }
                        query_data.perpage = perpage
                        let url = '/search-pagination?' + objToUrl(query_data);
                        if (this.dataRetrievalCancelTokenSource) {
                            this.dataRetrievalCancelTokenSource.cancel('Request cancelled')
                        }
                        this.dataRetrievalCancelTokenSource = this.axios.CancelToken.source();
                        this.axios.get(url, { cancelToken: this.dataRetrievalCancelTokenSource.token }).then(response => {
                            if ('/auctions/market-research-results' === window.location.pathname) {
                                if (response && response.data && response.data.results) {
                                    if (setviewed) {
                                        let query = JSON.parse(JSON.stringify(this.$route.query));
                                        query.cache_key = response.data.cache_key
                                        this.$router.replace({path: window.location.pathname, query})
                                        this.$route.query.cache_key = response.data.cache_key
                                        this.$nextTick(() => {
                                            setBackToAll(window.location.pathname + window.location.search);
                                        })
                                    }
                                    resolve(response.data)
                                } else {
                                    reject(response)
                                }
                            } else {
                                reject('url has changed')
                            }
                        }).catch(error => {
                            reject(error)
                        });
                    })
                }

                let fieldData = '';
                if (this.searchFieldData) {
                    fieldData = this.searchFieldData
                } else {
                    fieldData = this.searchfields
                }
                //this.searchFieldData = this.searchFields
                let data = {
                    currentPage: this.currentPage,
                    searchFields: fieldData,
                    perpage: this.perPage,
                    per_row: this.perRow,
                    sortorder: this.sortOrderBy
                };
                if (cache_key) {
                    data.cache_key = cache_key;
                }

                this.results = []
                this.setLoading(true);
                if (this.perPage > 50 && !cache_key) {
                    // doing it this way with promises to make both ajax calls run asyn and then if the 'all' query
                    // returns first for some reason, the first 50 call doesn't override the data.
                    let firstLoaded = false
                    let allLoaded = false
                    try {
                        const response = await retrieveData(50, false)
                        firstLoaded = true
                        if (!allLoaded) {
                            loadVehicles(response)
                        }
                        let perPage = this.perPage;
                        const allResponse = await retrieveData(perPage, true)
                        allLoaded = true
                        loadVehicles(allResponse)
                        afterLoaded()
                    } catch (e) {
                        if (!this.axios.isCancel(e)) {
                            onError(e)
                        }
                    }
                } else {
                    retrieveData(this.perPage, true).then(response => {
                        loadVehicles(response)
                        afterLoaded()
                    }).catch(onError)
                }

            },
            showMax() {
                this.perPage = 500;
                this.endNumber = 500;
                this.startFrom = 1;
                this.setSearchSettings()
                this.getData();
            },
            getSortOrderBy: function () {
                this.currentPage = 1;
                if (this.sortOrderBy !== this.$route.query.sort_by) {
                    let query = JSON.parse(JSON.stringify(this.$route.query))
                    query.sort_by = this.sortOrderBy
                    let query_string = objToUrl(query);
                    let base_url = this.$laravelRouter('search-vehicle', [], false);
                    let url = base_url + '?' + query_string;
                    this.$router.replace(url);
                }
                this.getData();
            },
            onSearch(data) {
                for (var propName in data) {
                    if (data[propName] === null || data[propName] === undefined) {
                        delete data[propName];
                    }
                }
                this.searchFieldData = data;
                this.getData();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/MarketResearchList.vue